import useTypedTranslation from "@/core/hooks/use-typed-translation";
import { FallingLines } from "react-loader-spinner";

export const LoadScreen = () => {
  const { t } = useTypedTranslation();

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex h-full w-full items-center justify-center"
    >
      <div className="mx-auto justify-center text-primary">
        <FallingLines color="currentColor" width="100" visible={true} />
      </div>
      <span className="sr-only">{t("common.loading")}</span>
    </div>
  );
};
